import axios from 'axios'
// eslint-disable-next-line import/no-internal-modules
import { publish } from '@insided/deprecated-utils/globals'
import { getInsidedData } from '@insided/destination/utils/insidedDataStorage'

export async function bulkApprove(posts: Object[]) {
  return await axios.post('/community/api/bulk/process', {
    action: 'approve',
    topics: posts
  })
}

export async function bulkResolve(posts: Object[]) {
  return await axios.post('/community/api/bulk/process', {
    action: 'resolveReportedContent',
    topics: posts
  })
}

export async function bulkRestore(posts: Object[]) {
  return await axios.post('/community/api/bulk/process', {
    action: 'restore',
    topics: posts
  })
}

export async function permanentlyDeleteSpamPosts(posts: Object[]) {
  await axios.post('/community/api/bulk/process', {
    action: 'permanentlyDelete',
    topics: posts
  })

  await axios.post('/community/api/invalidateCache?apiPath=spamContent/count')
  publish('posts_permanently_deleted_spam', {})
}

export async function emptyTrash() {
  const userId = getInsidedData('user').userid
  const { data } = await axios.post('/community/api/trashCan/startEmptying', null, {
    params: {
      moderatorId: userId
    }
  })
  return data
}